import { connect } from 'react-redux';
import getLocaleStringsById from 'stores/selectors/getLocaleStringsById';
import getLocale from 'stores/selectors/getLocale';
import Landing from './Landing';

const mapStateToProps = (state) => {
  const {
    AA_Prelogin_Hero_Headline,
    AA_Prelogin_Hero_Body,
    AA_Prelogin_CTA_Sign_in,
    AA_Prelogin_CTA_Join_for_free,
    AA_Prelogin_Subhero_Headline,
    AA_Prelogin_Subhero_Body,
    AA_Prelogin_Subhero_Body_2,
    AA_Prelogin_Block1_Title,
    AA_Prelogin_Block1_Headline,
    AA_Prelogin_Block1_Body,
    AA_Prelogin_Block2_Title,
    AA_Prelogin_Block2_Headline,
    AA_Prelogin_Block2_Body,
    AA_Prelogin_Block3_Title,
    AA_Prelogin_Block3_Headline,
    AA_Prelogin_Block3_Body,
    AA_Prelogin_Block4_Title,
    AA_Prelogin_Block4_Headline,
    AA_Prelogin_Block4_Body,
    AA_Prelogin_Final_Note,
  } = getLocaleStringsById(state);

  return {
    locale: getLocale(state),
    AA_Prelogin_Hero_Headline,
    AA_Prelogin_Hero_Body,
    AA_Prelogin_CTA_Sign_in,
    AA_Prelogin_CTA_Join_for_free,
    AA_Prelogin_Subhero_Headline,
    AA_Prelogin_Subhero_Body,
    AA_Prelogin_Subhero_Body_2,
    AA_Prelogin_Block1_Title,
    AA_Prelogin_Block1_Headline,
    AA_Prelogin_Block1_Body,
    AA_Prelogin_Block2_Title,
    AA_Prelogin_Block2_Headline,
    AA_Prelogin_Block2_Body,
    AA_Prelogin_Block3_Title,
    AA_Prelogin_Block3_Headline,
    AA_Prelogin_Block3_Body,
    AA_Prelogin_Block4_Title,
    AA_Prelogin_Block4_Headline,
    AA_Prelogin_Block4_Body,
    AA_Prelogin_Final_Note,
  };
};

export default connect(mapStateToProps)(Landing);
